module.exports = __webpack_public_path__ + "images/category_lp/musical_instrument/new/assessment_achievements/1_af55c8725bfaa187e10f8f73de18725a.png";